import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-contact-card',
  template: `
    <div class="relative">
      <a
        [routerLink]="link()"
        class="group peer relative mx-auto block aspect-video w-full cursor-pointer overflow-hidden rounded-3xl sm:w-5/6 xl:w-2/3"
      >
        <img
          [ngSrc]="image()"
          alt="{{ title() }}"
          title="{{ title() }}"
          class="aspect-video scale-100 transform rounded-3xl object-cover transition-transform duration-300 ease-out group-hover:origin-center group-hover:scale-110"
          [fill]="true"
        />

        <!-- Overlay gradient pour améliorer la lisibilité du texte -->
        <div
          class="absolute inset-x-0 bottom-0 h-2/3 rounded-3xl bg-linear-to-t from-stone-900 to-transparent"
        ></div>

        <div class="absolute bottom-6 left-8">
          <div
            class="inline-block rounded-full bg-yellow-300 px-2 font-bold text-secondary-900"
          >
            {{ badgeText() }}
          </div>
          <div class="mt-1.5 text-lg font-bold text-white sm:text-2xl" [innerHTML]="title()"></div>
        </div>
      </a>

      <!-- Background qui change au hover -->
      <div
        class="absolute -bottom-12 -z-10 hidden h-1/2 w-full rounded-3xl bg-secondary-100 transition-all duration-300 ease-out peer-hover:h-3/4 sm:block"
      ></div>
    </div>
  `,
  imports: [RouterLink, NgOptimizedImage],
})
export class ContactCardComponent {
  badgeText = input.required<string>();
  title = input.required<string>();
  image = input.required<string>();
  link = input.required<string>();
}
